/*----------------------------------------------------------------------------*\
  #SMART CHECK MODAL
\*----------------------------------------------------------------------------*/

import Modals from './modals';
import SmartCheckCardsClient from './smart-check-cards-client';

const SmartCheckModal = () => {
  const _settings = {
    openButton: '.js-openSmartCheckModal',
    modalsContainer: '.js-smartCheckModals',
    modal: '.js-smartCheckModal',
    modalContent: '.js-smartCheckModalContent',
    modalLoading: '.js-smartCheckModalLoading',
    modalError: '.js-smartCheckModalError',
  };

  const _modals = Modals({
    selector: _settings.modal,
    modalsSelector: _settings.modalsContainer,
  });
  const _client = SmartCheckCardsClient();

  const $openButton = () => document.querySelector(_settings.openButton);
  const $modal = () => document.querySelector(_settings.modal);
  const $modalContent = () => $modal()?.querySelector(_settings.modalContent);
  const $modalLoading = () => $modal()?.querySelector(_settings.modalLoading);
  const $modalError = () => $modal()?.querySelector(_settings.modalError);

  const _showLoading = () => {
    const loading = $modalLoading();
    const content = $modalContent();
    const error = $modalError();

    if (loading) loading.classList.remove('u-hide');
    if (content) content.classList.add('u-hide');
    if (error) error.classList.add('u-hide');
  };

  const _showContent = () => {
    const loading = $modalLoading();
    const content = $modalContent();
    const error = $modalError();

    if (loading) loading.classList.add('u-hide');
    if (content) content.classList.remove('u-hide');
    if (error) error.classList.add('u-hide');
  };

  const _showError = (message) => {
    const loading = $modalLoading();
    const content = $modalContent();
    const error = $modalError();

    if (loading) loading.classList.add('u-hide');
    if (content) content.classList.add('u-hide');
    if (error) {
      error.classList.remove('u-hide');
      error.textContent = message || 'Failed to load Smart Check details';
    }
  };

  const _fetchCardData = async ({ userId, siteId }) => {
    _showLoading();

    try {
      const html = await _client.fetch({ userId, siteId });
      const content = $modalContent();
      if (content) {
        content.innerHTML = html;
      }
      _showContent();
      return html;
    } catch (error) {
      _showError(error.message);
      return null;
    }
  };

  const _resetContent = () => {
    _showLoading();

    const content = $modalContent();
    if (content) content.innerHTML = '';
    const error = $modalError();
    if (error) error.textContent = '';
  };

  const _openModal = async (event) => {
    event.preventDefault();

    if (!$modal()) return;

    const button = event.currentTarget;
    const userId = button.dataset.userId;
    const siteId = button.dataset.siteId;

    _modals.open(_settings.modal);

    await _fetchCardData({ userId, siteId });
  };

  const destroy = () => {
    _modals.destroy();

    const button = $openButton();
    if (button) {
      button.removeEventListener('click', _openModal);
    }

    $modal()?.removeEventListener('modal:close', _resetContent);
  };

  const reinit = () => {
    destroy();
    init();
  };

  const init = () => {
    const button = $openButton();
    if (!button) return;

    _modals.init();
    button.addEventListener('click', _openModal);

    $modal()?.addEventListener('modal:close', _resetContent);
  };

  return {
    destroy,
    reinit,
    init,
  };
};

export default SmartCheckModal;
